const getMediaBaseUrl = () => {
  if (typeof window !== "undefined" && window.QRCODE_ENV?.MEDIA_URL) {
    return window.QRCODE_ENV.MEDIA_URL;
  }

  return process.env.REACT_APP_MEDIA_URL || process.env.MEDIA_URL || "https://media.ninecode.vn";
};

const normalizeBaseUrl = (url) => String(url || "").replace(/\/+$/, "");

const readRuntimeConfig = (runtimeKey, ...buildTimeKeys) => {
  if (typeof window !== "undefined" && window.QRCODE_ENV?.[runtimeKey] != null) {
    return window.QRCODE_ENV[runtimeKey];
  }
  for (const key of buildTimeKeys) {
    if (key && process.env?.[key] != null) {
      return process.env[key];
    }
  }
  return null;
};

const toPositiveInt = (value, fallback) => {
  const parsed = Number.parseInt(String(value ?? ""), 10);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback;
  }
  return parsed;
};

export const GUEST_DYNAMIC_QR_LIMIT = toPositiveInt(
  readRuntimeConfig(
    "GUEST_DYNAMIC_QR_LIMIT",
    "NEXT_PUBLIC_GUEST_DYNAMIC_QR_LIMIT",
    "REACT_APP_GUEST_DYNAMIC_QR_LIMIT"
  ),
  10
);

export const GUEST_QR_STORAGE_DAYS = toPositiveInt(
  readRuntimeConfig(
    "GUEST_QR_STORAGE_DAYS",
    "NEXT_PUBLIC_GUEST_QR_STORAGE_DAYS",
    "REACT_APP_GUEST_QR_STORAGE_DAYS"
  ),
  1
);

export const GUEST_QR_STORAGE_TTL_MS = GUEST_QR_STORAGE_DAYS * 24 * 60 * 60 * 1000;
export const GUEST_MERGE_FLAG_STORAGE_KEY = "qr_guest_needs_merge";
export const GUEST_LAST_CREATED_AT_STORAGE_KEY = "qr_guest_last_created_at";

export const hasActiveGuestMergeIntent = () => {
  if (typeof window === "undefined" || typeof window.localStorage === "undefined") {
    return false;
  }
  if (window.localStorage.getItem(GUEST_MERGE_FLAG_STORAGE_KEY) !== "1") {
    return false;
  }

  const createdAt = Number(
    window.localStorage.getItem(GUEST_LAST_CREATED_AT_STORAGE_KEY) || 0
  );
  const isExpired =
    !createdAt ||
    !Number.isFinite(createdAt) ||
    Date.now() - createdAt > GUEST_QR_STORAGE_TTL_MS;

  if (isExpired) {
    window.localStorage.removeItem(GUEST_MERGE_FLAG_STORAGE_KEY);
    window.localStorage.removeItem(GUEST_LAST_CREATED_AT_STORAGE_KEY);
    return false;
  }

  return true;
};

export const MEDIA_IMAGE_URL = `${normalizeBaseUrl(getMediaBaseUrl())}/api/files/view`;
export const LANGUAGE_LIST = [
    {
        value: 'vi',
        label: 'Tiếng Việt'
    },
    {
        value: 'en',
        label: 'English'
    }
]
